export function configureAndroidInterestForm(): void {
  const form = document.querySelector<HTMLFormElement>("#android-interest-form");
  if (!form) return;
  const button = form.querySelector<HTMLButtonElement>("button[type=submit]")!;
  const status = document.querySelector<HTMLElement>("#android-interest-status")!;
  button.disabled = false;
  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    if (button.disabled || !form.reportValidity()) return;
    button.disabled = true;
    button.textContent = "Joining…";
    status.textContent = "";
    status.dataset.state = "pending";
    const data = new FormData(form);
    try {
      const result = await fetch("/api/android-interest", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: data.get("email"), website: data.get("website"), consent: data.get("consent") === "on" }),
        signal: AbortSignal.timeout(20_000),
      });
      const body = await result.json() as { ok?: boolean; message?: string; error?: string };
      if (!result.ok || body.ok !== true) throw new Error(body.error || "We couldn't save your email. Please try again.");
      status.textContent = body.message || "You're on the list. Thank you!";
      status.dataset.state = "success";
      button.textContent = "You're on the list";
      form.querySelectorAll<HTMLInputElement>("input").forEach((input) => { input.disabled = true; });
    } catch (error) {
      status.textContent = error instanceof Error && error.name === "Error"
        ? error.message : "We couldn't confirm your signup. Please try again — your email won't be added twice.";
      status.dataset.state = "error";
      button.disabled = false;
      button.textContent = "Join the Android waitlist";
    }
  });
}
